import { LanderCplQuizQuestion } from "./lander-cpl-quiz.types";

export const skipLanderCplQuiz = () => {
  window.theme.LanderCplQuizUtils.handleVideoAdsQuizNextSweepStep();
  return new Promise((resolve) => setTimeout(resolve, 5000));
};

export const entriesCount = (
  cplQuizQuestions: LanderCplQuizQuestion[],
  defaultEntries: number
): number => {
  return cplQuizQuestions.reduce(
    (acc, question) =>
      question.options.some((option) => option.isSelected && option.isCorrect)
        ? acc + 1
        : acc,
    defaultEntries
  );
};
